import { gql } from '@apollo/client';

export const PROPERTY_CONTACTS_FIELDS = gql`
    fragment PropertyContactsFields on Property {
        contacts {
            id
            recordId
            prefix
            lastName
            firstName
            middleName
            lastName
            suffix
            title
            photoUrl
            company {
                id
                recordId
                name
                addresses {
                    city
                    stateProvince
                    preferredMailing
                }
                primaryBusinessType {
                    code
                    name
                }
            }
            address {
                city
                stateProvince
            }
        }
    }
`;
